import {ApplicationStoreType} from 'desktop/store';

/**
 * Get special offer
 *
 * @param {ApplicationStoreType} store - Application store type.
 * @returns {string} - specialOffer banner content
 */
export const getSpecialOfferBanner = (store: ApplicationStoreType) =>
    store.cart.specialOffer.bannerContent;

/**
 * Get special offer banner content type
 */
export const getSpecialOfferBannerContentType = (
    store: ApplicationStoreType,
): 'json' | 'html' | null => store.cart.specialOffer.contentType;
